import { TextStyle } from 'pixi.js';

const RENDERER_CONFIG = {
	RENDERER_SCALE: 0.25,
	COLORS: {
		RED: 0xff0000,
		WHITE: 0xffffff,
		BLACK: 0x000000,
		GRAY: 0xc9c9c9,
		LIGHT_GRAY: 0xced4da,
		DARK_GRAY: 0x828282,
	},
	METRICS: {
		Z_INDEX: 1,
		EDGES_LENGTH: 35,
		ARROW_LINE_OFFSET: 30,
		ARROW_LENGTH: 11.25,
		ARROW_WIDTH: 7.5,
		TEXT_RESOLUTION: 2,
		TEXT_TO_LINE_OFFSET: 10,
		TEXT_STYLE: new TextStyle({
			fontFamily: 'IBMPlexSans',
			fontSize: 20,
			fill: 0x000000,
		}),
	},
	SEGMENT_DIVISION: {
		Z_INDEX: 4,
	},
	ARMOR_RUNNERS: {
		Z_INDEX: 4,
	},
	ARMOR: {
		Z_INDEX: 3,
		SHELL_HEIGHT: 40,
		MAX_SHELLS_QUANTITY: 15,
	},
	SEGMENT: {
		Z_INDEX: 1,
	},
	WINDOW: {
		Z_INDEX: 1,
	},
	ROLLER_BOX: {
		Z_INDEX: 1,
		DRIVER_JUNCTION_HALF_LENGTH: 10,
	},
	WING: {
		Z_INDEX: 1,
	},
} as const;

export default RENDERER_CONFIG;
